import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import {validateCaptcha} from '../../utils/captcha';
import {FormValidationError} from '../../utils/forms/formerror';
import {validateContactUsFormFeilds} from '../../utils/validate';

class ContactUsForm extends Component {
    
    constructor(props){
        super(props);
        this.state = {
            captcha: '',
            contact_form: {
                first_name: '',
                last_name: '',
                email: '',
                company: '',
                message: ''
            },
            formSubmitErrorMessage: '',
            formValidationErrors: [],
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.isDisabled = this.isDisabled.bind(this);
        this.getRecaptcha = this.getRecaptcha.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.resetForm = this.resetForm.bind(this);
    }

    getRecaptcha(response){
        this.setState({captcha: response})
    }
    isDisabled(){
        return this.state.captcha ? false : true;
    }
    resetForm(){
        this.setState({contact_form: {first_name: "", last_name: "", email: "", company: "", message: ""}})
    }

    handleInputChange(event) {
        //Needs to be done this way since setstate doesnt merge updates to nested properties
        let contact_form = {...this.state.contact_form};
        contact_form[event.target.name] = event.target.value;

        this.setState({contact_form: {...contact_form}});
    }

    handleSubmit(event){
        event.preventDefault();
        
        let validate = validateContactUsFormFeilds(this.state.contact_form);
        
        if(validate.length > 0){
            return this.setState({formValidationErrors: validate})
        }
        
        this.handleValidFormSubmission();
    }

    async handleValidFormSubmission(){
        let captchaResponse = await validateCaptcha('/contact-us-form', this.state.captcha, 'contact_us', this.state.contact_form);
        
        //Error At captcha level
        if(!captchaResponse.data.success){
            this.setState({formSubmitErrorMessage: 'Something went wrong, please try again.'})
        }
        if(captchaResponse.data.success){
            window.location = '/thank-you';
        }
    }

    render() {
        return (
                <form className="text-center" name="contact_form" onSubmit={this.handleSubmit} id="mentor-form">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="firstname" className="bmd-label-floating">First name:</label>
                                <input name="first_name" type="text" className="form-control" id="firstname" onChange={this.handleInputChange} required />
                                <span className="bmd-help"></span> 
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="lastname" className="bmd-label-floating">Last name:</label>
                                <input name="last_name" type="text" className="form-control" id="lastname" onChange={this.handleInputChange} required />
                                <span className="bmd-help"></span> 
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="email" className="bmd-label-floating">Email:</label>
                                <input name="email" type="email" className="form-control" id="email" onChange={this.handleInputChange} required />
                                <span className="bmd-help"></span> 
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="company" className="bmd-label-floating">School or Organization (optional):</label>
                                <input name="company" type="text" className="form-control" id="company" onChange={this.handleInputChange} />
                                <span className="bmd-help"></span> 
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="message" className="bmd-label-floating" spellCheck="true">Message</label>
                                <textarea name="message" className="form-control" id="message" rows="3" onChange={this.handleInputChange} required></textarea>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="captcha">
                            <div className="g-recaptcha">
                                <ReCAPTCHA 
                                    sitekey={'6LftsnQUAAAAAOQ5ajH0z7S-guXL-znpoTu2iLeI'} 
                                    onChange={this.getRecaptcha} 
                                    className={'center'} />
                            </div> 
                        </div>
                    </div>
                    <div className="col-md-12 rule"></div>

                    <FormValidationError 
                        errors={this.state.formValidationErrors}
                    />
                    {/* Submit Button */}
                    <button name="submit" className="btn btn-mid-green btn-mid-green--cr451 bradius-0 ttrans-n btn-raised" type="submit" disabled={this.isDisabled()}>Submit Form</button>
                    <button name="reset" className="btn btn-dark-orange bradius-0 ttrans-n btn-raised" type="reset" onClick={this.resetForm}>Reset Form</button>
                </form>                    
        );
    }
}

export default ContactUsForm;